<template>
  <div class="content">
    <div class="form-box">
      <el-form :inline="true" :model="formInline" :label-position="labelPosition" :rules="rules" ref="formInline"
               class="demo-form-inline">
        <el-form-item label="公司名称" prop="company">
          <el-input v-model="formInline.company" placeholder="公司名称"></el-input>
        </el-form-item>
        <el-form-item label="职位" prop="enterprise_job" v-if="formInline.enterprise_job != '其他'">
          <el-select v-model="formInline.enterprise_job" placeholder="职位">
            <el-option label="董事长" value="董事长">董事长</el-option>
            <el-option label="股东" value="股东">股东</el-option>
            <el-option label="总经理" value="总经理">总经理</el-option>
            <el-option label="副总经理" value="副总经理">副总经理</el-option>
            <el-option label="财务总监" value="财务总监">财务总监</el-option>
            <el-option label="销售总监" value="销售总监">销售总监</el-option>
            <el-option label="人力资源总监" value="人力资源总监">人力资源总监</el-option>
            <el-option label="运营总监" value="运营总监">运营总监</el-option>
            <el-option label="其他" value="其他" @click="houver">其他</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="职位" prop="enterprise_jobs" v-else>
          <el-input v-model="formInline.enterprise_jobs" placeholder="职位"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="user_name">
          <el-input v-model="formInline.user_name" placeholder="姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机" prop="phone">
          <el-input maxlength="11" v-model.number="formInline.phone" autocomplete="off" placeholder="手机"></el-input>
        </el-form-item>
        <div class="tishi">*以下两项请必须填写一项</div>
        <el-form-item label="推荐人" prop="tj_user">
          <el-input v-model="formInline.tj_user" placeholder="推荐人"></el-input>
        </el-form-item>
        <el-form-item label="推荐场所" prop="address">
          <el-input v-model="formInline.address" placeholder="推荐场所"></el-input>
        </el-form-item>
        <el-form-item label="服务方式" prop="service_type">
          <el-select v-model="formInline.service_type" placeholder="服务方式" v-if="uname == '传统行业'">
            <el-option label="OEM" value="OEM">OEM</el-option>
            <el-option label="ODM" value="ODM">ODM</el-option>
            <el-option label="OBM" value="OBM">OBM</el-option>
          </el-select>
          <el-select v-model="formInline.service_type" placeholder="服务方式" v-else>
            <el-option v-for="(index,key) in service_types" :key="key" :label="index"
                       :value="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="人员规模" prop="personnel_size">
          <el-select v-model="formInline.personnel_size" placeholder="人员规模" v-if="uname == '传统行业'">
            <el-option v-for="(index,key) in personnel_sizess" :key="key" :label="index"
                       :value="index"></el-option>
          </el-select>
          <el-select v-model="formInline.personnel_size" placeholder="人员规模" v-else>
            <el-option v-for="(index,key) in personnel_sizesss" :key="key" :label="index"
                       :value="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="企业年限" prop="enterprise_years">
          <el-select v-model="formInline.enterprise_years" placeholder="企业年限">
            <el-option v-for="(index,key) in enterprise_yearss" :key="key" :label="index"
                       :value="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="btn-form">
          <el-button @click="resetForm('formInline')">重置</el-button>
          <el-button type="primary" @click="onSubmit('formInline')">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" custom-class="xiepulou">
     <div class="img-box">
       <img src="/static/image/tianjia.jpg" alt="" class="ti-pic">
       <img src="/static/image/shoukuan.png" alt="" class="ti-pic">
     </div>
      <span>此次诊断费用<div class="feiyong">{{text}}</div>，请扫码付款，添加右侧二维码微信，获取测评二维码和链接，后续一对一跟进服务</span>
<!--      <el-button class="btn" type="danger" @click="to">确定</el-button>-->
    </el-dialog>
  </div>
</template>
<script>
var indexurl = localStorage.getItem('url')
export default {

  data() {
    return {
      uname:'',
      id: '',
      dialogVisible: false,
      labelPosition: 'right',
      text:'',
      formInline: {
        company: '',
        enterprise_job: '',
        enterprise_jobs: '',
        user_name: '',
        phone: '',
        tj_user: '',
        address: '',
        service_type: "",
        personnel_size: "",
        enterprise_years: ""
      },
      service_types: [],
      personnel_sizes: [],
      personnel_sizess: [],
      personnel_sizesss: [],
      enterprise_yearss: [],
      show:true,
      shows:false,
      rules: {
        company: [
          {required: true, message: '请输入公司名称', trigger: 'blur'}
        ],
        enterprise_job: [
          {required: false, message: '请选择职位', trigger: 'change'}
        ],
        enterprise_jobs: [
          {required: false, message: '请输入公司职位', trigger: 'blur'}
        ],
        user_name: [
          {required: true, message: '请输入姓名', trigger: 'blur'}
        ],
        phone: [
          {required: true, message: '请输入手机', trigger: 'blur'},
          {type: 'number', message: '手机必须为数字值'}
        ],
        tj_user: [
          {required: false, message: '请输入推荐人', trigger: 'blur'}
        ],
        address: [
          {required: false, message: '请输入推荐场所', trigger: 'blur'}
        ],
        enterprise_years: [
          {required: true, message: '请选择企业年限', trigger: 'change'}
        ],
        service_type: [
          {required: true, message: '请选择服务方式', trigger: 'change'}
        ],
        personnel_size: [
          {required: true, message: '请选择人员规模', trigger: 'change'}
        ]
      }
    }
  },
  created() {
    this.id = this.$route.query.id
    this.uname = this.$route.query.name
    this.serviceMode()
    this.personnelSize()
    this.enterpriseYears()
  },
  methods: {
    houver(){
      this.show = false
      this.shows = true
    },
    serviceMode() {
      let that = this
      this.$axios({
        method: "GET",
        url: indexurl + "/index.php/api/index/getServerType",
        data: {}
      })
        .then(function (res) {
          console.log(res,'service_type')
          let arr = Object.keys(res.data.data).map(key => {
            //console.log(key); //为每个键名
            console.log(res.data.data);
            return res.data.data[key];  //把每个对象返回出去生成一个新的数组中相当于0:{id:1}
          });
          that.service_types = arr
          console.log(that.service_types,'that.service_types')
          console.log(arr,'arr')
        })
    },
    personnelSize() {
      let that = this
      this.$axios({
        method: "GET",
        url:indexurl + "/index.php/api/index/getPersonnelSize",
        data: {}
      })
        .then(function (res) {
          let arr = Object.keys(res.data.data).map(key => {
            //console.log(key); //为每个键名
            return res.data.data[key];  //把每个对象返回出去生成一个新的数组中相当于0:{id:1}
          });
          that.personnel_sizes = arr
          console.log(that.personnel_sizes,'that.personnel_sizes')

            that.personnel_sizess.push(that.personnel_sizes[0])
          that.personnel_sizess.push(that.personnel_sizes[1])
          that.personnel_sizess.push(that.personnel_sizes[2])
          that.personnel_sizesss.push(that.personnel_sizes[3])
          that.personnel_sizesss.push(that.personnel_sizes[4])
          that.personnel_sizesss.push(that.personnel_sizes[5])
          console.log(that.personnel_sizess,'that.personnel_sizess')
        })
    },
    enterpriseYears() {
      let that = this
      this.$axios({
        method: "GET",
        url: indexurl + "/index.php/api/index/getCompanyYears",
        data: {}
      })
        .then(function (res) {
          let arr = Object.keys(res.data.data).map(key => {
            //console.log(key); //为每个键名
            console.log(res.data.data);
            return res.data.data[key];  //把每个对象返回出去生成一个新的数组中相当于0:{id:1}
          });
          that.enterprise_yearss = arr
        })
    },
    // cepingren() {
    //   let that = this
    //   this.$axios({
    //     method: "GET",
    //     url: "http://www.gdqyzx.com/index.php/api/index/getCompanyYears",
    //     data: {}
    //   })
    //     .then(function (res) {
    //       let arr = []
    //       for (let i = 0; i < res.data.data.length; i++) {
    //         arr.push({
    //           value: i + 1,
    //           label: res.data.data[i]
    //         })
    //       }
    //       that.enterprise_years = arr
    //     })
    // },
    onSubmit(formName) {
      if(this.formInline.enterprise_job != '其他'){
        this.formInline.enterprise_job = this.formInline.enterprise_job
      }else {
        this.formInline.enterprise_job = this.formInline.enterprise_jobs
      }
      console.log(this.formInline.enterprise_job,'this.formInline.enterprise_job')
      if (this.formInline.tj_user == '' && this.formInline.address == '') {
        alert("推荐人与场所两项必填一项")
      } else {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let that = this
            this.$axios({
              method: "POST",
              url: indexurl + "/index.php/api/index/addInfo",
              data: {
                company: this.formInline.company,
                job: this.formInline.enterprise_job,
                user_name: this.formInline.user_name,
                phone: this.formInline.phone,
                tj_user: this.formInline.tj_user,
                address: this.formInline.address,
                service_type: this.formInline.service_type,
                personnel_size: this.formInline.personnel_size,
                enterprise_years: this.formInline.enterprise_years,
                cp_category_id: this.id
              }
            })
              .then(function (res) {
                console.log(that.id,'that.id')
                console.log(that.formInline.service_type,'that.formInline.service_type')
                console.log(that.formInline.personnel_size,'that.formInline.personnel_size')

                that.$axios({
                  method: "GET",
                  url: indexurl + "/index.php/api/index/retFee?cp_category_id="+ that.id +"&service_type="+that.formInline.service_type+"&personnel_size="+that.formInline.personnel_size,
                  data: {

                  }
                })
                  .then(function (res) {
                    that. resetForm('formInline')
                    that.dialogVisible = true;
                    console.log(res.data.data,457)
                    that.text = res.data.data.fee

                  })
              })
          } else {
            console.log('error submit!!');
            return false;
          }
        })
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // to(){
    //   this.$router.push({
    //     path: '/',
    //
    //   })
    // }
  }
}
</script>
<style scoped>
.content {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 50px 0;

}
.form-box {
  /*position: absolute;*/
  /*top: 50%;*/
  /*left: 50%;*/
  /*transform: translate(-50%, -50%);*/
  width: 50%;
  box-shadow: 0 0 15px 15px rgba(0, 0, 0, 0.34);
  padding: 20px;
  border-radius: 10px;
}
.demo-form-inline {
  display: flex;
  flex-direction: column;
}
.ti-pic {
  width: 50%;
}
.el-form-item {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
/deep/ .el-form--inline .el-form-item__label {
  width: 30%;
  text-align: start;
}
/deep/ .el-form--inline .el-form-item__content {
  width: 70%;
}
.el-select {
  width: 100%;
}
/deep/ .btn-form .el-form-item__content {
  width: 100%;
  flex: unset;
  display: flex;
  justify-content: space-between;
}
.tishi{
  font-size: 12px;
  color: red;
  margin-bottom: 22px;
}
.feiyong{
  font-size: 24px;
  color: red;
  display: initial;
}
.img-box{
  display: flex;justify-content: space-between;align-items: center;
}
@media (max-width: 800px) {
  .form-box {
    width: 80%;
    position: unset;
    top: unset;
    left: unset;
    transform: unset;
    margin: 20px auto;
  }
  /deep/ .el-form--inline .el-form-item__content{
    width: 100%;
  }
}
@media (max-width: 768px) {
  .form-box {
    width: 80%;
    position: unset;
    top: unset;
    left: unset;
    transform: unset;
  }
  .img-box{
    display: flex;justify-content: space-between;align-items: center;flex-direction: column;
  }
  .ti-pic {
    width: 100%;
  }
  /deep/.el-dialog{
    width: 80%!important;
  }
}
@media (max-width: 480px) {
  /deep/ .el-form--inline .el-form-item__label {
    width: 36%;
    text-align: start;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/information/index.vue